/**
 * Origins allowed to drive the booking site preview over postMessage. Kept as a
 * list because prod and staging business-web sit on different hosts.
 */
export const BUSINESS_WEB_ORIGINS = [
  'https://app.getporter.io',
  'https://business-web-w74fr6mhza-uc.a.run.app',
  ...(process.env.REACT_APP_BUSINESS_WEB_URL
    ? [process.env.REACT_APP_BUSINESS_WEB_URL]
    : []),
  ...(process.env.NODE_ENV === 'development' ? ['http://localhost:3000'] : []),
];

export const DEFAULT_CUSTOMER_SERVICE_FEE = 0.035;
export const TOP_BAR_HEIGHT = 63;
export const TOPBAR_MARGIN_TOP = `var(--topbar-height, ${TOP_BAR_HEIGHT}px)`;
export const PROGRESS_BAR_HEIGHT = 90;
export const FORM_CONTENT_MARGIN_TOP = `calc(${TOPBAR_MARGIN_TOP} + ${PROGRESS_BAR_HEIGHT}px)`;
/** Both artist pages render the same load failure, so they say the same thing. */
export const ARTIST_PAGE_LOAD_ERROR =
  "There was an error loading this artist's page. Please double check that you've entered the URL in correctly, and if the error persists, reach out to our support team using the help icon below.";
export const SHOP_PAGE_LOAD_ERROR =
  "There was an error loading this shop's page. Please double check that you've entered the URL in correctly, and if the error persists, reach out to our support team using the help icon below.";
export const ARTIST_NOT_BOOKABLE_ERROR =
  'This artist is not currently accepting bookings. Please contact support.';
export const DEFAULT_TATTOO_SERVICE_ID = 'TATTOO';
export const DEFAULT_FLASH_SERVICE_ID = 'FLASH';
export enum LoginSteps {
  Phone = 'PHONE',
  Verify = 'VERIFY',
}
